<template>
    <IntegrationBox
        :active="active"
        title="Slack"
        :name="integration?.name"
        documentation-url=""
        integration-type="Sign-in"
        @openNew="$emit('openNew')"
        @openEdit="$emit('openEdit')"
        @openRemove="$emit('openRemove')"
    >
        <template #logo>
            <SlackLogo class="h-8 w-[90px]" />
        </template>
    </IntegrationBox>
</template>

<script lang="ts" setup>
import type { IIntegration, ISlack } from "@/types/Integrations/IIntegration";
import type { PropType } from "vue";

defineEmits(["openNew", "openEdit", "openRemove"]);

defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    active: {
        type: Boolean,
        required: false,
        default: false,
    },
    integration: {
        type: Object as PropType<IIntegration<ISlack>>,
        required: false,
        default: () => ({}),
    },
});
</script>
